import React from 'react';
import Checkbox from '../components/Checkbox';

function Boolean({ data, isHideMarkIcon = false, state = 'update' }) {
    return <Checkbox isHideMarkIcon={isHideMarkIcon} data={data} state={state} />;
}

export default React.memo(Boolean);
